import React, { useEffect } from 'react';
import { Button } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import EditIcon from '@mui/icons-material/Edit';
import { DashboardDocument } from './DashboardDocument';
import DashboardDialog from './DashboardDialog';
import APIRequest from 'system/APIRequest';
import { enqueueSnackbar } from 'notistack';

export interface DashboardSelectionButtonProps {
  selectedDashboardId: string;
  setSelectedDashboardId: (dashboardId: string | undefined, dashboard?: DashboardDocument) => void;

  limitToTemplateDashboards?: boolean;

  size?: "small" | "medium" | "large";
  
  // Dashboards in the list must match the given dataset.
  datasetId?: string;
}

export default function DashboardSelectionButton(props: DashboardSelectionButtonProps): JSX.Element {
  const { i18n } = useTranslation();

  const [dialogOpen, setDialogOpen] = useState<boolean>(false);

  const [selectedDashboard, setSelectedDashboard] = useState<DashboardDocument | undefined>(undefined);

  // Load the selected dashboard from the selectedDashboardId
  useEffect(() => {
    if (!props.selectedDashboardId) {
      setSelectedDashboard(undefined);
      return;
    }
    APIRequest(`obj/dashboard/${props.selectedDashboardId}`).then((response: any) => {
      setSelectedDashboard(response.output);
      props.setSelectedDashboardId(response.output.id, response.output);
    }).catch((reason: APIError) => {
      enqueueSnackbar(`${i18n.t('resources.dashboards.dashboard-load-error')} ${reason.message}`, {variant: 'error', persist: true});
    });
  }, [props.selectedDashboardId]);

  return (
  <>
    <Button
      variant={selectedDashboard ? "outlined" : "contained"}
      onClick={() => setDialogOpen(true)}
      size={props.size || "medium"}
      endIcon={<EditIcon />}>
      {selectedDashboard ? selectedDashboard.name : i18n.t('resources.dashboards.select-dashboard')}
    </Button>
    {dialogOpen &&
      <DashboardDialog
        datasetId={props.datasetId}
        open={dialogOpen}
        limitToTemplateDashboards={props.limitToTemplateDashboards}
        onClose={() => setDialogOpen(false)}
        onSubmit={(dashboard: DashboardDocument | undefined) => {
          if (dashboard === undefined) {
            return;
          }
          setSelectedDashboard(dashboard);
          props.setSelectedDashboardId(dashboard.id, dashboard);
          setDialogOpen(false);
        }}
      />
    }
  </>
  );
}